var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 146,
    viewBox: "0 0 192 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8997 6.51149C68.2856 0.804034 78.309 -0.366037 87.4342 0.0885305C116.093 1.51954 141.962 15.4108 164.34 31.1254C172.441 36.8132 180.417 42.9442 185.674 50.7785C196.386 66.7261 193.204 88.8182 178.32 101.956C173.255 106.425 167.116 109.858 160.813 112.89C149.607 118.289 137.515 122.625 124.796 123.865C115.728 124.744 106.545 124.03 97.5277 122.803C72.3362 119.365 47.6129 111.779 26.8815 98.8011C17.7911 93.1097 9.22376 86.0323 5.47613 76.8286C1.72954 67.6239 4.12746 55.946 13.4104 50.4865C17.2488 48.2323 21.8402 47.2134 26.3325 46.2566C32.9477 44.8494 39.6687 43.4619 45.6363 40.602C51.8037 37.6473 59.1033 31.9331 57.8792 25.3921C56.5762 18.3825 55.5222 12.219 61.8997 6.51149Z",
    fill: "#DEFFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2659 39.5355C33.9225 39.5355 36.8868 36.5854 36.8868 32.9463C36.8868 29.3072 33.9225 26.3571 30.2659 26.3571C26.6093 26.3571 23.645 29.3072 23.645 32.9463C23.645 36.5854 26.6093 39.5355 30.2659 39.5355Z",
    fill: "#BBFFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9706 18.8268C20.5823 18.8268 22.6995 16.7195 22.6995 14.1201C22.6995 11.5206 20.5823 9.41338 17.9706 9.41338C15.3589 9.41338 13.2417 11.5206 13.2417 14.1201C13.2417 16.7195 15.3589 18.8268 17.9706 18.8268Z",
    fill: "#BBFFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89146 32.0051C2.93608 32.0051 3.78292 31.1623 3.78292 30.1226C3.78292 29.0829 2.93608 28.2401 1.89146 28.2401C0.846835 28.2401 0 29.0829 0 30.1226C0 31.1623 0.846835 32.0051 1.89146 32.0051Z",
    fill: "#BBFFEF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6797 33.0312L116.491 16.9857L138.669 120.307L63.8583 136.352L41.6797 33.0312Z",
    fill: "#F0EFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.8483 34.3668L115.96 18.8048L137.338 119.013L65.2266 134.574L43.8483 34.3668Z",
    fill: "url(#paint0_linear_6709_21267)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.397 35.0441L114.839 19.9362L135.795 117.56L65.3525 132.667L44.397 35.0441Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3292 26.9859L96.275 19.4906L98.091 27.9522L63.1457 35.4473L61.3292 26.9859Z",
    fill: "url(#paint1_linear_6709_21267)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1663 15.0867C74.3594 15.6743 72.5842 18.4214 73.2017 21.2223C73.8187 24.0232 76.5923 25.8203 79.3935 25.2326C82.1951 24.6445 83.976 21.8969 83.3585 19.0965C82.741 16.2956 79.9731 14.4985 77.1663 15.0862V15.0867ZM78.9275 23.096C77.7142 23.3781 76.4465 22.9163 75.7195 21.928C75.3646 21.448 75.1645 20.8717 75.1458 20.2756C75.1271 19.6795 75.2906 19.0918 75.6147 18.5907C76.2779 17.5609 77.5139 17.0245 78.7433 17.2337C79.9715 17.4429 80.9487 18.3556 81.2149 19.5438C81.3048 19.9239 81.3169 20.3181 81.2504 20.703C81.184 21.0878 81.0404 21.4553 80.8283 21.7835C80.3931 22.4541 79.7099 22.9259 78.9275 23.096Z",
    fill: "url(#paint2_linear_6709_21267)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6191 26.544L95.8289 19.2068L97.5647 27.2953L63.3554 34.632L61.6191 26.544Z",
    fill: "#84DCC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8152 15.0799C74.2622 15.6262 72.6374 18.1315 73.1854 20.6766C73.7329 23.2213 76.2465 24.8412 78.7991 24.2956C81.3521 23.7493 82.9769 21.244 82.4294 18.6989C82.2991 18.0936 82.0506 17.52 81.698 17.0106C81.3454 16.5012 80.8957 16.0661 80.3745 15.7302C79.3213 15.0514 78.0411 14.8175 76.8152 15.0799ZM78.3793 22.352C77.8518 22.4648 77.3026 22.4192 76.8011 22.2208C76.2995 22.0224 75.8682 21.6801 75.5615 21.2373C75.255 20.7947 75.087 20.2712 75.0789 19.7332C75.0708 19.1953 75.2228 18.667 75.5159 18.2153C75.8092 17.7637 76.2302 17.4089 76.7255 17.1958C77.2208 16.9827 77.7683 16.9208 78.2989 17.0179C78.8294 17.115 79.3193 17.3668 79.7065 17.7414C80.0937 18.1161 80.361 18.5968 80.4747 19.1229C80.6259 19.8283 80.4902 20.5648 80.0972 21.1704C79.7043 21.776 79.0863 22.201 78.3793 22.352Z",
    fill: "#84DCC8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9702 30.0569H151.569V135.631H74.9702V30.0569Z",
    fill: "#F0EFEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.9648 31.9631H149.596V133.664H75.9648V31.9631Z",
    fill: "url(#paint3_linear_6709_21267)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8613 31.9424H148.732V131.861H76.8613V31.9424Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8291 28.1718H130.764V36.6553H94.8291V28.1718Z",
    fill: "url(#paint4_linear_6709_21267)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27 19.6883C110.398 19.6883 108.069 22.0087 108.069 24.8723C108.069 27.7364 110.398 30.0569 113.27 30.0569C116.142 30.0569 118.471 27.7364 118.471 24.8723C118.471 22.0092 116.142 19.6883 113.27 19.6883ZM113.27 27.8637C112.021 27.8927 110.878 27.1824 110.38 26.0672C110.136 25.522 110.065 24.9158 110.176 24.3292C110.286 23.7427 110.573 23.2036 110.998 22.7838C111.871 21.9135 113.198 21.6442 114.356 22.1024C115.513 22.5611 116.269 23.6561 116.269 24.8723C116.282 26.4995 114.941 27.8301 113.27 27.8492V27.8637Z",
    fill: "url(#paint5_linear_6709_21267)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7749 27.229H130.765V35.7125H95.7749V27.229Z",
    fill: "#84DCC8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.797 19.6883C111.862 19.688 110.948 19.9643 110.17 20.4822C109.393 21 108.786 21.7363 108.428 22.5979C108.07 23.4591 107.977 24.4069 108.159 25.3211C108.342 26.2354 108.792 27.0751 109.453 27.7338C110.115 28.393 110.958 28.8418 111.875 29.0236C112.792 29.2054 113.742 29.1121 114.606 28.7553C115.47 28.3989 116.208 27.795 116.728 27.02C117.247 26.2449 117.524 25.3336 117.525 24.4012C117.525 21.798 115.407 19.6883 112.797 19.6883ZM112.797 27.1213C112.074 27.1209 111.381 26.8342 110.87 26.3241C110.358 25.8141 110.071 25.1224 110.071 24.4012C110.071 22.8997 111.29 21.6831 112.797 21.681C113.52 21.6798 114.213 21.9648 114.725 22.4734C115.238 22.9821 115.527 23.6728 115.529 24.3939C115.529 25.1162 115.24 25.8078 114.728 26.3178C114.215 26.8278 113.521 27.1138 112.797 27.113V27.1213Z",
    fill: "#84DCC8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6709_21267",
    x1: 5815.5,
    y1: 9289.58,
    x2: 3668.09,
    y2: -741.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6709_21267",
    x1: 1991.16,
    y1: 500.307,
    x2: 1809.71,
    y2: -347.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6709_21267",
    x1: 705.102,
    y1: 1039.34,
    x2: 483.193,
    y2: 26.2959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6709_21267",
    x1: 3757.44,
    y1: 10202.1,
    x2: 3757.44,
    y2: 31.9631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6709_21267",
    x1: 1891.59,
    y1: 876.525,
    x2: 1891.59,
    y2: 28.1718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6709_21267",
    x1: 628.181,
    y1: 1055.66,
    x2: 628.181,
    y2: 18.7966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.445846c86e71409e04ccbcfe4553ad94.svg";
export { ForwardRef as ReactComponent };